var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes},[_c('Icon',{staticClass:"mr-2",attrs:{"icon":_vm.icon}}),_vm._v(_vm._s(_vm.text)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }